export class AccountBalance {
  balanceTypeCd: string;
  instrumentId: string;
  balanceAmount: string;
  currencyCd: string;
  txIsoCntryCd: string;
  pv: string;
  bv: string;
}
